<div class="modal">
  <div class="container model-container {{data.customClass}}">
    <img src="assets/icon/popup-close-icon.svg" (click)="closeDialog()" class="close-icon"
    width="32" height="32" alt="Close Icon">

    <div class="modal-header">
      <h2 class="modal-heading">{{data.title}}</h2>
    </div>
    <div id="modal-body-section" class="modal-body">
      <p [innerHTML]="data.subtitle"></p>
      <div class="modal-content">
        <mat-tab-group animationDuration="0ms" (selectedTabChange)="tabChanged($event)" [selectedIndex]="selectedIndex">
          <mat-tab [label]="innerWidth >= 640 ? 'Unlimited Global' : 'UNTLD. Global'">
            <inter-calling-price-table #intCalling [inModal]="true" categoryId="int-calling"
              valueTitle="Minutes"></inter-calling-price-table>
          </mat-tab>
          <mat-tab label="Pay As you Go">
            <inter-calling-price-table #payGo [inModal]="true" categoryId="pay-go" valueTitle="Price"></inter-calling-price-table>
          </mat-tab>
        </mat-tab-group>
      </div>
    </div>
  </div>
</div>
